import en from './en.json'
import es from './es.json'
import pt from './pt.json'
import it from './it.json'
import jp from './jp.json'
    const LANGUAGES = {en: {name: 'English', data: en},es: {name: 'Español', data: es},pt: {name: 'Português', data: pt},it: {name: 'Italiano', data: it},jp: {name: '日本語', data: jp}};
    module.exports = LANGUAGES;